import {
    addProxyEndpoint,
    getProxyUserListEndpoint,
    getProxyListEndpoint,
    revokeProxyEndpoint,
    updateProxyEndpoint,
} from 'src/pages/more/pages/proxies/redux/services/endpoints.js';
import axios from 'src/api/Api';

export const addProxiesService = async (queryParams) => {
    try {
        const response = await axios.post(addProxyEndpoint(queryParams));
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const updateProxiesService = async (queryParams) => {
    try {
        const response = await axios.post(updateProxyEndpoint(queryParams));
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const revokeProxiesService = async (queryParams) => {
    try {
        const response = await axios.delete(revokeProxyEndpoint(queryParams));
        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getProxyUserListService = async (data) => {
    try {
        const response = await axios.get(getProxyUserListEndpoint(data));

        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};

export const getProxyListService = async () => {
    try {
        const response = await axios.get(getProxyListEndpoint());

        return response ? response.data : {};
    } catch (error) {
        return {};
    }
};
